import styled from '@emotion/styled';
import React from 'react';

export interface IProps {
  color: 'blue' | 'multi';
  animation: 'bounce' | 'fade';
  size: '10px' | '32px';
}

const Host = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;

  @keyframes fadedelay {
    0%,
    80%,
    100% {
      transform: scale(0);
      -webkit-transform: scale(0);
    }
    40% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }

  @keyframes bouncedelay {
    0% {
      transform: translateY(0px);
    }
    35% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
    70% {
      transform: translateY(3px);
    }
    85% {
      transform: translateY(0px);
    }
  }
`;

const Circle = styled.div<IProps>`
  float: left;
  height: ${({ size }) => size};

  width: ${({ size }) => size};
  border-radius: 100%;

  ${({ animation }) =>
    animation === 'fade' &&
    'animation: fadedelay 1s ease-in-out infinite both'};

  ${({ animation }) =>
    animation === 'bounce' &&
    'animation: bouncedelay 1.4s ease-in-out infinite'};

  &:not(:first-of-type) {
    margin-left: ${({ size }) => (size === '10px' ? '6px' : '32px')};
  }
`;

const CircleOne = styled(Circle)`
  animation-delay: -0.32s;

  ${({ color }) => color === 'blue' && 'background-color: #bfe1f2'};

  ${({ color, theme }) =>
    color === 'multi' && `background-color: ${theme.colors.primary}`};
`;
const CircleTwo = styled(Circle)`
  animation-delay: -0.16s;

  ${({ color }) => color === 'blue' && 'background-color: #9fd6f1'};

  ${({ color, theme }) =>
    color === 'multi' && `background-color: ${theme.colors.secondary}`};
`;
const CircleThree = styled(Circle)`
  ${({ color }) => color === 'blue' && 'background-color: #85d7fb'};

  ${({ color, theme }) =>
    color === 'multi' && `background-color: ${theme.colors.ternary}`};
`;

export function LoadingCircles({ color, animation, size }: IProps) {
  return (
    <Host>
      <CircleOne size={size} animation={animation} color={color} />
      <CircleTwo size={size} animation={animation} color={color} />
      <CircleThree size={size} animation={animation} color={color} />
    </Host>
  );
}
